import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { useMeQuery } from '@/store/services/auth';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, token } = useSelector((state: RootState) => state.auth);
  
  // Skip fetching user data if not authenticated
  const { isLoading, error } = useMeQuery(undefined, { 
    skip: !isAuthenticated || !token 
  });

  // First check authentication status
  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Then handle loading state
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Finally handle errors
  if (error) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}